import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

export const parseErrorInterceptor: HttpInterceptorFn = (req, next) =>
    next(req).pipe(
        catchError((event: HttpErrorResponse) => {
            if (req.responseType !== 'text') return throwError(() => event);
            let parsedError = {};

            try {
                parsedError = JSON.parse(event.error);
            } catch {}

            const response: HttpErrorResponse = { ...event, error: parsedError };

            return throwError(() => response);
        }),
    );
